<template>
<a href="/coupon/list.html?level=1" :class="current" :data-scp="scp">
	<i class="icon icon-coupon"></i><span>优惠</span>
</a>
</template>

<script>
export default {
	props: ['scp', 'current']
};
</script>